export default __webpack_public_path__ + "static/media/sprinter.8f48c906.png";